/**
 * Super Admin platform-wide settings (SaaS toggles).
 */
import API_CONFIG from '../../config';
import axios from 'axios';
import { getSuperAdminAuthHeader } from './superAdminAuthService';

const API_URL = API_CONFIG.BASE_URL;

export const getPlatformSettings = async () => {
  const response = await axios.get(`${API_URL}/superadmin/platform-settings`, {
    headers: getSuperAdminAuthHeader()
  });
  return response.data;
};

export const updatePlatformSettings = async (payload) => {
  const response = await axios.put(`${API_URL}/superadmin/platform-settings`, payload, {
    headers: getSuperAdminAuthHeader()
  });
  return response.data;
};
